import { useEffect } from 'react';
import { useTonConnectUI } from '@tonconnect/ui-react';

import { useBindTonWalletMutation } from '@/api/queries/payment';

const useBindTonWallet = (): void => {
  const [tonConnectUI] = useTonConnectUI();
  const [bindTonWallet] = useBindTonWalletMutation();

  useEffect(() => {
    const unsubscribe = tonConnectUI.onStatusChange((wallet) => {
      const address = wallet?.account.address;

      const alreadyBound = localStorage.getItem('ton_wallet');

      if (address && !alreadyBound) {
        bindTonWallet({ walletAddress: address })
          .unwrap()
          .then(() => {
            console.log('✅ Wallet is connected');
            localStorage.setItem('ton_wallet', 'true');
          })
          .catch((err) => {
            console.error('❌ Err conected wallet', err);
          });
      }
    });

    return (): void => unsubscribe();
  }, [tonConnectUI, bindTonWallet]);
};

export { useBindTonWallet };
